/* ============================================================
   PanOxyl landing — interacciones + trigger Releasit COD.
   Cargado por layout/landing.liquid (case 'panoxyl').
   Bloques: tabs ciencia · videos (toca para oír) · galería cliqueable +
   lightbox · animación de barras y números (count-up al hacer scroll) ·
   barra sticky móvil · selección de bundle · disparo del modal Releasit.
   Patrón Releasit: NO usar _rsiV2.setState como primer path — el click
   nativo del botón Releasit SÍ re-lee window.productData. Ver
   memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- Tabs de ciencia ---------- */
(function () {
  document.querySelectorAll('.nx-tabs').forEach(function (group) {
    group.querySelectorAll('.nx-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.nx-tab').forEach(function (b) { b.classList.remove('nx-tab-on'); });
        btn.classList.add('nx-tab-on');
        var id = btn.getAttribute('data-tab');
        document.querySelectorAll('.nx-tabpanel').forEach(function (p) {
          if (p.id === id) { p.classList.add('nx-tab-on'); }
          else if (['sci-1', 'sci-2', 'sci-3'].indexOf(p.id) > -1) { p.classList.remove('nx-tab-on'); }
        });
      });
    });
  });
})();

/* ---------- Videos: toca para activar/silenciar el audio doblado ---------- */
(function () {
  document.querySelectorAll('.nx-vid-thumb video').forEach(function (v) {
    v.muted = true;
    var b = document.createElement('div');
    b.className = 'nx-vid-badge';
    v.parentNode.appendChild(b);
    function upd() { b.textContent = v.muted ? '🔇 Toca para oír' : '🔊 Con sonido'; }
    v.parentNode.addEventListener('click', function () {
      var on = v.muted;
      document.querySelectorAll('.nx-vid-thumb video').forEach(function (o) { if (o !== v) { o.muted = true; } });
      document.querySelectorAll('.nx-vid-badge').forEach(function (bb) { if (bb !== b) { bb.textContent = '🔇 Toca para oír'; } });
      v.muted = !on;
      if (!v.muted) { v.play().catch(function () {}); }
      upd();
    });
    upd();
  });
})();

/* ---------- Galería del buy box: thumbnail cambia la imagen principal ---------- */
(function () {
  var main = document.querySelector('.nx-buy-main img');
  var thumbs = document.querySelectorAll('.nx-buy-thumb');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var img = thumb.querySelector('img');
      var src = img ? img.getAttribute('src') : null;
      if (src) main.setAttribute('src', src);
      thumbs.forEach(function (t) { t.classList.remove('nx-buy-thumb--active'); });
      thumb.classList.add('nx-buy-thumb--active');
    });
  });
})();

/* ---------- Lightbox: cualquier imagen [data-zoom] abre en grande ---------- */
(function () {
  var lb = document.createElement('div');
  lb.className = 'nx-lb';
  lb.innerHTML = '<span class="nx-lb-x" aria-label="Cerrar">&times;</span><img alt="">';
  document.body.appendChild(lb);
  var lbImg = lb.querySelector('img');
  function open(src) { if (!src) return; lbImg.setAttribute('src', src); lb.classList.add('nx-lb--open'); }
  function close() { lb.classList.remove('nx-lb--open'); }
  lb.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.querySelectorAll('[data-zoom]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var img = el.matches('img') ? el : el.querySelector('img');
      if (!img) return;
      e.stopPropagation();
      open(img.getAttribute('src'));
    });
  });
})();

/* ---------- Animación de barras + count-up de números al entrar en viewport ---------- */
(function () {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 1300, start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(frame);
  }

  function reveal(el) {
    el.classList.add('nx-in');
    // barras dentro del bloque
    el.querySelectorAll('.nx-bar i[data-w]').forEach(function (bar) {
      var w = bar.getAttribute('data-w');
      requestAnimationFrame(function () { bar.style.width = w + '%'; });
      setTimeout(function () { bar.classList.add('nx-bar--done'); }, 1500);
    });
    // números count-up dentro del bloque (o el propio nodo)
    var nums = el.matches('[data-count]') ? [el] : el.querySelectorAll('[data-count]');
    nums.forEach(countUp);
  }

  var targets = document.querySelectorAll('.nx-reveal, .nx-press-logo[data-count]');
  if (prefersReduced || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('nx-in');
      el.querySelectorAll && el.querySelectorAll('.nx-bar i[data-w]').forEach(function (bar) { bar.style.width = bar.getAttribute('data-w') + '%'; });
      var nums = el.matches('[data-count]') ? [el] : (el.querySelectorAll ? el.querySelectorAll('[data-count]') : []);
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-count') + (n.getAttribute('data-suffix') || ''); });
    });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { reveal(entry.target); io.unobserve(entry.target); }
    });
  }, { threshold: 0.3 });
  targets.forEach(function (el) { io.observe(el); });
})();

/* ============================================================
   Selección de bundle + Releasit COD trigger
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  var selectedVariantId = null;
  var selectedQty = 1;

  // Cada bundle = una variante con precio POR UNIDAD; mandamos la cantidad real
  // (1/2/3) para que el pedido llegue con las unidades exactas (Dropi envía la
  // cantidad) y el total quede en el precio del bundle. Releasit lee el
  // input[name="quantity"] del DOM al disparar COD (verificado 2026-06-06).
  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  var stickyPrice = document.getElementById('nx-sticky-price');

  function bundleQty(el) {
    var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
    if (!q) { var idx = parseInt(el.getAttribute('data-bundle-index'), 10); q = isNaN(idx) ? 1 : idx + 1; }
    return q || 1;
  }

  function selectBundle(el) {
    var id = el.getAttribute('data-bundle-variant-id');
    if (!id) return;
    document.querySelectorAll('.nx-opt').forEach(function (x) { x.classList.remove('nx-opt-on'); });
    el.classList.add('nx-opt-on');
    selectedVariantId = id;
    selectedQty = bundleQty(el);
    setVariantOnAllForms(id, selectedQty);
    // sincroniza precio de la barra sticky + select del formulario
    var price = el.getAttribute('data-price');
    if (price && stickyPrice) stickyPrice.textContent = price;
    var sel = document.getElementById('nx-plan');
    var idx = el.getAttribute('data-bundle-index');
    if (sel && idx != null) sel.selectedIndex = parseInt(idx, 10);
  }

  var opts = document.querySelectorAll('.nx-opt[data-bundle-variant-id]');
  opts.forEach(function (el) {
    el.addEventListener('click', function () { selectBundle(el); });
  });

  // El <select> del formulario final también cambia el bundle
  (function () {
    var sel = document.getElementById('nx-plan');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var target = document.querySelector('.nx-opt[data-bundle-index="' + sel.selectedIndex + '"]');
      if (target) selectBundle(target);
    });
  })();

  // Init: bundle marcado activo (o el primero)
  (function initSelected() {
    var active = document.querySelector('.nx-opt.nx-opt-on[data-bundle-variant-id]') || opts[0];
    if (active) {
      selectedVariantId = active.getAttribute('data-bundle-variant-id');
      selectedQty = bundleQty(active);
      setVariantOnAllForms(selectedVariantId, selectedQty);
      var price = active.getAttribute('data-price');
      if (price && stickyPrice) stickyPrice.textContent = price;
    }
  })();

  window.panoxylTriggerCOD = function (btn) {
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || selectedQty;
    if (variantId) setVariantOnAllForms(variantId, qty);
    setTimeout(function () {
      var releasitBtn = findReleasitButton();
      if (releasitBtn) { releasitBtn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();

/* ---------- Barra sticky móvil: aparece tras pasar el hero ---------- */
(function () {
  var bar = document.getElementById('nx-sticky');
  if (!bar) return;
  var hero = document.querySelector('.nx-hero');
  function onScroll() {
    var bottom = hero ? hero.getBoundingClientRect().bottom : 500;
    if (bottom < 0) { bar.classList.add('nx-sticky--show'); }
    else { bar.classList.remove('nx-sticky--show'); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
